import * as React from "react"
import * as styles from "./styles.css"
import { MdOpenInNew } from "react-icons/md"
import { useActiveCmsIntegrationsForSiteQuery } from "./queries.generated"

import {
  SupportedCmsVendor,
  dataSourceLogos,
  systemEventNames,
} from "../../constants/data-sources"

type DataSourceProps = {
  name: string
  cmsVendor: SupportedCmsVendor
  siteId: string
}

export function DataSource({ cmsVendor, name, siteId }: DataSourceProps) {
  const { data, loading, error } = useActiveCmsIntegrationsForSiteQuery({
    variables: {
      siteId,
    },
  })

  const integrationData = data?.activeCmsIntegrationsForSite || []

  const cmsVendorData = integrationData.filter(
    data => data.vendor === cmsVendor
  )

  let sourceUrl
  let sourceName

  if (cmsVendorData.length > 0) {
    const configItems = Object.entries(cmsVendorData[0].config)
    sourceName = configItems.find(item => item[0].endsWith(`Name`))?.[1]
    sourceUrl = cmsVendorData[0].config.managementUrl
  }

  const Icon = dataSourceLogos?.[cmsVendor]

  return (
    <div className={styles.title}>
      Data source
      <div className={styles.sourceUrlDetails}>
        {Icon && <Icon />}
        {!systemEventNames.includes(name) && sourceUrl ? (
          <a
            href={sourceUrl}
            target="_blank"
            rel="noreferrer noopener"
            className={styles.sourceUrl}
          >
            {sourceName}&nbsp;
            <MdOpenInNew />
          </a>
        ) : (
          name
        )}
      </div>
    </div>
  )
}
